import {AnalysisItem, MobileAnalysisItem} from '@/map/@types';
import {AreaAnalyticsVars} from '@/map/@types/query-variables';
import {AreaOverlayType, CoordType} from '@/map/enums';
import {getPolygonCoords} from '@/map/utils';

export const getAreaQueryVariables = (
  item: AnalysisItem
): AreaAnalyticsVars | undefined => {
  if (!item) {
    return;
  }

  const {type} = item;

  const variant: AreaAnalyticsVars = {};

  if (type === AreaOverlayType.CIRCLE) {
    const circle = item[AreaOverlayType.CIRCLE];

    if (!circle || !circle.center || !circle.radius) {
      return;
    }

    const center = circle.center as naver.maps.LatLng;

    variant.lat = center.lat();
    variant.lng = center.lng();
    variant.radius = circle.radius;
  } else if (type === AreaOverlayType.POLYGON) {
    const polygon = item[AreaOverlayType.POLYGON];

    if (!polygon || !polygon.paths) {
      return;
    }

    const coordinates = getPolygonCoords(polygon.paths);

    variant.polygon = {
      coordinates,
      type: CoordType.Polygon,
    };
  } else if (type === AreaOverlayType.EMD) {
    const emd = item[AreaOverlayType.EMD];

    if (!emd || !emd.code) {
      return;
    }

    variant.admCode = emd.code;
  }

  return variant;
};

export const convertToVarsFromMobileVars = (item: MobileAnalysisItem) => {
  if (item) {
    return {
      type: AreaOverlayType.CIRCLE,
      id: item.center.toString() + item.radius + item.keyword,
      [AreaOverlayType.CIRCLE]: {
        center: item.center,
        radius: item.radius,
      },
    };
  }
};
